<template>
    <div id="singleRangeSelectorDiv">
        <div id="maxBoundSelectorDiv" class="singleRangeSelect">
            <div class="boundTitle">
                Show vehicles under:
            </div>
            <select id="maxBoundSelector" v-model="maxRangeSelected">
                <option v-for="(rangeBound, index) in possibleRangeBounds" :value="rangeBound" v-bind:key="index" class="maxRangeBoundOption" :disabled="rangeBound <= minRangeSelected">
                    {{ formatNumber(rangeBound) }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'filterName',
        ],
        data () {
            return {
            }
        },
        computed: {
            maxRangeSelected: {
                get() {
                    return this.$store.getters.getFilterSelectedByName(this.filterName).max;
                },
                set(max) {
                    this.$store.commit('setRangeMaxSelected', {name: this.filterName, value: max});
                    this.$store.commit('notifySearchQueryChanges', true);
                }
            },
            possibleRangeBounds() {
                let possibleValues = [-400, -300, -100, 0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1500, 2000, 2500, 3000];

                return possibleValues;
            }
        },
        methods: {
            defaultMinBound() {
                return this.$store.getters.getAvailableFilters[this.filterName].default.min;
            },
            defaultMaxBound() {
                return this.$store.getters.getAvailableFilters[this.filterName].default.max;
            },
            formatNumber(mv) {
                var cv = "";
                var neg = false;

                if (parseInt(mv) < 0) {
                    neg = true;
                }

                cv = new Intl.NumberFormat('en', {
                        style: 'currency',
                        currency: 'USD'
                    }).format(Math.abs(Math.ceil(mv)));

                if (neg) {
                    cv = "(" + cv + ")";
                }
        
                return cv.replace(".00","");
            }
        }
    }
</script>
<style>
    #singleRangeSelectorDiv {
        min-width: calc(28 * var(--vw));
        width: fit-content;
        height: 100%;
        display: flex;
        /*flex-direction: column;*/
        justify-content: center;
        align-items: center;
    }

    .inmobile #singleRangeSelectorDiv {
        height: 100%;
        width: inherit;
        justify-content: space-around;
        align-items: center;
    }

    .boundTitle {
        margin: calc(.5 * var(--vh));
    }

    .singleRangeSelect {
        width: fit-content;/*35%;*/
        text-align: right; 
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-direction: column;
    }

    .inmobile .singleRangeSelect {
        width: 86%;
    }

    .singleRangeSelect > select {
        width: fit-content; /*calc(100% - .4vw);*/
        font-size: 1.2em;
    }

    .inmobile .singleRangeSelect > select {
        font-size: 2em;
    }
</style>